import * as cdpSelectors from 'pluginServices/selectors';

export const selectCoursewareItem = (state, activityId) => {
  const coursewareItem = cdpSelectors.getCoursewareItem(state, activityId);
  return coursewareItem && coursewareItem.toJS();
};

export const selectPluginManifest = (state, pluginId, pluginVersion) => {
  const manifest = cdpSelectors.getPluginManifest(state, pluginId, pluginVersion);
  return manifest && manifest.toJS();
};
